export const SET_MODAL_INACTIVITY = 'SET_MODAL_INACTIVITY';

export const setDataPlay = (payload) => (dispatch) => {
    dispatch({
        type: SET_MODAL_INACTIVITY,
        payload,
    });
};



// WEBPACK FOOTER //
// ./src/actions/modalInactivity.js